import { Location } from 'history';
import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { history } from '@hypercharge/digitaldealer-commons/lib/providers/router/history';
import { useTenant } from '../tenant/TenantProvider';

const sendPageView = (location: Location, _action?: any): void => {
  const page = location.pathname + location.search;
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

type Props = {
  children: JSX.Element;
};

const AnalyticsTracking = ({ children }: Props): JSX.Element => {
  const { tenant } = useTenant();

  useEffect((): (() => void) | void => {
    if (process.env.REACT_APP_GA_TRACKING_ID) {
      ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
      ReactGA.set({ dimension1: tenant.id });
      // send initial pageview
      sendPageView(history.location as any, 'REPLACE');
      // subscribe to subsequent navigation events
      return history.listen(sendPageView as any);
    }
  }, [tenant]);

  return children;
};

export default AnalyticsTracking;
